import axios from "axios";

import Config from "./Config";
import APIHelper from "./APIHelper";

class EbayService {
    static EBAY_ID = 769;
    static #ebayWebsites = null;

    static Inject(list) {
        EbayService.#ebayWebsites = list;
    }

    static Load(list = null) {
        return new Promise((resolve, reject) => {
            if (list !== null) {
                EbayService.#ebayWebsites = list;
                resolve(EbayService.#ebayWebsites);
                return;
            }
            if (EbayService.#ebayWebsites === null) {
                axios
                    .get(`${Config.API_URL}website/ebay`)
                    .then((response) => {
                        if (APIHelper.checkStatus(response)) {
                            EbayService.#ebayWebsites = response.data.items;
                            resolve(EbayService.#ebayWebsites);
                            return;
                        }
                        reject();
                    })
                    .catch(reject);
            } else {
                resolve(EbayService.#ebayWebsites);
            }
        });
    }

    /**
     * Should return a list of eBay websites filtered by country ID. If the country ID is not found,
     * it should include Ebay.com website among results.
     */
    static async FilterByCountryID(countryID) {
        return await EbayService.Load()
            .then((items) => {
                const filter =
                    typeof countryID === "number" ? [countryID] : countryID;
                let ebayComIsAmongResult = false,
                    ebayProfile,
                    filteredList = items.filter((website) => {
                        const shouldInclude =
                            filter.indexOf(website.country_id) !== -1;
                        if (website.id === EbayService.EBAY_ID) {
                            ebayProfile = website;
                            if (shouldInclude) {
                                ebayComIsAmongResult = true;
                            }
                        }
                        return shouldInclude;
                    }),
                    missingCountries = filter.length - filteredList.length > 0;

                return missingCountries && !ebayComIsAmongResult
                    ? [ebayProfile, ...filteredList]
                    : filteredList;
            })
            .catch(() => false);
    }
}

export default EbayService;
